import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const HeroSection = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const handleClaimClick = () => {
    // For Android detection
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isUS = true; // In a real app, you would use geolocation or IP-based detection
    
    if (isAndroid && isUS) {
      window.location.href = "https://singingfiles.com/show.php?l=0&u=2389716&id=67673";
    } else {
      setIsDialogOpen(true);
    }
  };

  return (
    <section className="pt-24 pb-12 md:pt-32 md:pb-20 bg-gradient-to-b from-background to-secondary/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center lg:text-left"
          >
            <div className="inline-block bg-secondary/30 text-secondary-foreground px-4 py-1 rounded-full text-sm font-medium mb-4">
              Limited Time Offer • US Only
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-6 leading-tight">
              Get the latest{" "}
              <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                Buffalo Wild Wings
              </span>{" "}
              Samples Now!
            </h1>
            
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 mb-8">
              Experience the bold flavors of Buffalo Wild Wings with our exclusive sampling offer. Available for a limited time only for Android users in the United States.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <Button 
                size="lg" 
                className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8"
                onClick={handleClaimClick}
              >
                Claim Your Free Samples <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              
              <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                <DialogContent className="sm:max-w-md">
                  <DialogHeader>
                    <DialogTitle>Device Not Compatible</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-4 py-4">
                    <p className="text-muted-foreground">
                      This offer is only available for Android devices in the United States. Please access this page from an Android device to claim your free samples.
                    </p>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 text-sm text-muted-foreground">
              <div className="flex items-center">
                <CheckCircle2 className="text-primary mr-2 h-5 w-5" />
                <span>100% Free</span>
              </div>
              <div className="flex items-center">
                <CheckCircle2 className="text-primary mr-2 h-5 w-5" />
                <span>No Credit Card Required</span>
              </div>
              <div className="flex items-center">
                <CheckCircle2 className="text-primary mr-2 h-5 w-5" />
                <span>Limited Quantity</span>
              </div>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="relative"
          >
            <div className="relative mx-auto max-w-md">
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-secondary/40 rounded-full blur-xl"></div>
              <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-primary/30 rounded-full blur-xl"></div>
              
              <img
                src="https://images.unsplash.com/photo-1568901346375-23c9450c58cd?q=80&w=1899&auto=format&fit=crop"
                alt="Buffalo Wild Wings"
                className="relative z-10 rounded-xl shadow-xl animate-float object-cover h-[400px] w-full"
              />
              
              <div className="absolute -bottom-4 -right-4 bg-white rounded-lg shadow-lg p-4 z-20 max-w-[200px]">
                <div className="flex items-center space-x-2">
                  <div className="h-3 w-3 bg-green-500 rounded-full animate-pulse"></div>
                  <p className="text-sm font-medium">Limited samples left</p>
                </div>
                <p className="text-xs text-muted-foreground mt-1">
                  87 people claimed in the last hour
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;